import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { NavLink } from "react-router-dom";
import { getRequestsToApprove } from "../../actions/index";
import { getAllMyResources, logout } from "../../actions/api";
import { CernToolbar } from "@authzsvc/common-react-components";
import { BellOutlined, ReadOutlined } from "@ant-design/icons";
import PropTypes from "prop-types";

const HeaderMenuItems = ({
  authenticated,
  getRequestsToApprove,
  keycloak,
  userToken,
  requests,
  getAllMyResources,
  resources,
  loading,
}) => {
  const [firstRequests, setFirstRequests] = useState(false);
  const [resourcePendingActionLength, setResourcePendingActionLength] =
    useState(0);

  useEffect(() => {
    if (authenticated && !firstRequests) {
      getRequestsToApprove();
      getAllMyResources();
      setFirstRequests(true);
    }
  }, [getRequestsToApprove, getAllMyResources, authenticated, firstRequests]);

  useEffect(() => {
    var count = 0;
    Object.keys(resources || []).forEach((key) => {
      count += resources[key].filter(
        (resource) => resource.internalState === "ActionRequired",
      ).length;
    });
    setResourcePendingActionLength(count);
  }, [resources, resourcePendingActionLength]);

  const menuItems = [
    {
      key: "requiredactions",
      icon: <BellOutlined />,
      label: (
        <NavLink to="/required-actions">
          ( {requests.length + resourcePendingActionLength} ) Required actions
        </NavLink>
      ),
    },
    {
      key: "docs",
      icon: <ReadOutlined />,
      label: (
        <NavLink to="https://auth.docs.cern.ch/resources/overview/">
          Docs
        </NavLink>
      ),
    },
  ];

  return (
    <CernToolbar
      extraLogoutFct={logout}
      authenticated={authenticated}
      keycloak={keycloak}
      userToken={userToken}
      menuItems={menuItems}
      loading={loading}
    ></CernToolbar>
  );
};

HeaderMenuItems.propTypes = {
  authenticated: PropTypes.bool,
  getRequestsToApprove: PropTypes.func.isRequired,
  keycloak: PropTypes.object,
  userToken: PropTypes.object,
  requests: PropTypes.array,
  getAllMyResources: PropTypes.func.isRequired,
  resources: PropTypes.object,
  loading: PropTypes.bool,
};

export default connect(
  (state) => ({
    authenticated: state.keycloak.authenticated,
    keycloak: state.keycloak.instance,
    userToken: state.keycloak.userToken,
    requests: state.requests.toApprove.filter((r) => r.status === "Pending"),
    resources: state.resources.data,
    loading: state.requests.loading || state.resources.loading,
  }),
  {
    getRequestsToApprove,
    logout,
    getAllMyResources,
  },
)(HeaderMenuItems);
